module.exports = __webpack_public_path__ + "img/noData.04a3ee5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/blockChain/noData.png
// module id = yuJR
// module chunks = 10